import React, { useEffect, useState } from "react"
import {
  map,
  get,
  toNumber,
  range,
  chunk,
  clone,
  find,
  size,
  filter,
  isEmpty,
} from "lodash"
import ClassNames from "classnames"
import dayjs from "dayjs"
import store from "redux/store"

import { Panel } from "./index"
import { BaseTable } from "components/molecules/table"
import { filterColumns, tableColumns } from "config/table_columns"
import { Pagination } from "components/molecules/pagination"
import { APIResponse } from "redux/apis/types"
import * as Formatter from "utils/Formatter"
import { checkIsSp, open_symbol_detail } from "utils/util"
import { BaseSelect } from "components/atoms/input/select"
import { Labels } from "components/atoms/input/input"
import { SearchToggle } from "components/molecules/filter/toggleFilter"
import { setSymbols, setMonth } from "redux/ducks/Calender"
import { PAGE_NUM } from "config/const"
import {
  calenderApi,
  label,
} from "components/actions/getProfitAnnouncementCalender"
import { showSymbol } from "redux/ducks/SymbolDetail"
import { changeSpModalSymbol } from "redux/ducks/Chart"
import { pageLoad } from "redux/ducks/PageLoad"

const getCalendarList = (today: string | number) => {
  const localedToday = dayjs(String(today)).locale("ja")
  const startOfMonth = localedToday.startOf("month").format("YYYY/MM/DD")

  const lastOfMonth = localedToday.endOf("month")

  const lastDayInLastMonth = localedToday.subtract(1, "month").endOf("month")

  const lastDayInLastMonthDay = toNumber(lastDayInLastMonth.format("D"))

  const nextMonth = localedToday.add(1, "month").format("YYYYMM")
  const startDayOfWeek = Formatter.date(startOfMonth, "d")
  const firstSunDay =
    toNumber(startDayOfWeek) === 0 ? 1 : 8 - toNumber(startDayOfWeek)
  const dayList = range(firstSunDay, toNumber(lastOfMonth.format("D")) + 1)
  const dayLists = dayList.map(row => {
    const day = String(row)
    return toNumber(
      Formatter.date(String(today), "YYYYMM") +
        (day.length === 1 ? "0" : "") +
        day
    )
  })
  const weekDaysList: Array<Array<number>> = chunk(dayLists, 7)

  if (firstSunDay !== 1) {
    const firstWeek: Array<number> = []
    for (let i = 1; i < 8; i++) {
      const setDay = firstSunDay - i
      if (setDay > 0) {
        const day = toNumber(
          Formatter.date(String(today), "YYYYMM") + "0" + String(setDay)
        )
        firstWeek.unshift(day)
      } else {
        const day = toNumber(
          lastDayInLastMonth.format("YYYYMM") +
            String(lastDayInLastMonthDay + setDay)
        )
        firstWeek.unshift(day)
      }
    }
    weekDaysList.unshift(firstWeek)
  }
  const lastWeekList = clone(weekDaysList[weekDaysList.length - 1])
  if (lastWeekList.length !== 7) {
    for (let i = 1; i < 8 - lastWeekList.length; i++) {
      const day: number = toNumber(nextMonth + "0" + String(i))
      weekDaysList[weekDaysList.length - 1].push(day)
    }
  }
  return weekDaysList
}

const Calender = (props: {
  displayList: object
  setDisplayList: Function
  calenderData: APIResponse.Res
  selectMonth: string
}) => {
  const monthOfToday = Formatter.date(props.selectMonth, "MM")
  const weekDaysList = getCalendarList(props.selectMonth)

  return (
    <table className="table table-calendar">
      <thead>
        <tr>
          <th>日</th>
          <th>月</th>
          <th>火</th>
          <th>水</th>
          <th>木</th>
          <th>金</th>
          <th>土</th>
        </tr>
      </thead>
      {!!props.selectMonth && (
        <tbody>
          {map(weekDaysList, (weeks, key) => {
            return (
              <tr key={key}>
                {map(weeks, (day, i) => {
                  const data = find(
                    props.calenderData.ResultList,
                    row => row.Date === day
                  )
                  const dataSize = size(get(data, "Symbols"))
                  return (
                    <td
                      key={i}
                      className={ClassNames({
                        active: !!dataSize,
                        disabled:
                          monthOfToday !== Formatter.date(String(day), "MM"),
                        select:
                          get(data, "Date") ===
                          get(props.displayList, "[0].AnnounceDate", []),
                      })}
                      onClick={() => {
                        if (!dataSize) return
                        store.dispatch(setSymbols(get(data, "Symbols", [])))
                        props.setDisplayList(get(data, "Symbols", []))
                      }}
                    >
                      <div
                        className={ClassNames({
                          up: i === 0,
                          down: i === weeks.length - 1,
                        })}
                      >
                        {Formatter.date(String(day), "D")}
                      </div>
                      {!!dataSize ? (
                        <div className="calendar-result">
                          {dataSize}
                          <span className="unit">件</span>
                        </div>
                      ) : null}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      )}
    </table>
  )
}

type VerticalCalendar = {
  list: Array<object>
  data: object
}

const VerticalCalendar = (props: VerticalCalendar) => {
  const [currentPage, changePage] = useState<number>(0)
  const [currentToggle, switchTheToggle] = useState<boolean>(false)
  const list: Array<Array<object>> = chunk(get(props.data, "Symbols", []), 10)

  return (
    <>
      <SearchToggle
        title={
          <>
            <span>
              {Formatter.date(String(get(props.data, "Date")), "YYYY/MM/DD")}
            </span>
            <span style={{ paddingLeft: "3em" }}>
              {size(get(props.data, "Symbols"))}件
            </span>
          </>
        }
        active={currentToggle}
        onToggle={() =>
          currentToggle ? switchTheToggle(false) : switchTheToggle(true)
        }
      >
        {!isEmpty(get(props.data, "Symbols")) && (
          <div
            className={ClassNames(
              "panel-filter-list-col search-toggle-JPindustry",
              {
                "is-open": currentToggle,
              }
            )}
          >
            <BaseTable
              className="table-striped"
              list={props.list}
              data={list[currentPage]}
              spFilter={filterColumns.settlement}
              onClick={(data: object) =>
                store.dispatch(changeSpModalSymbol(data))
              }
            />
            <Pagination
              list={get(props.data, "Symbols")}
              current={currentPage}
              page={PAGE_NUM.PAGE_10}
              changePage={changePage}
            />
          </div>
        )}
      </SearchToggle>
    </>
  )
}

type Props = {
  calenderData: APIResponse.Res
  settlementMonth?: number
  changeSettlementMonth?: Function
  displayType?: object
  changeDisplayType?: Function
  updateFunc?: Function
  foreignCurrentPage?: number
  foreignChangePage?: Function
}

const getMonthList = (systemDay: number | string, format: string) => {
  const formatDay = Formatter.date(String(systemDay), "YYYYMM")
  const prevMonth = !!systemDay
    ? Formatter.date(String(Number(formatDay) - 1), format)
    : formatDay
  const currentMonth = Formatter.date(formatDay, format)
  const nextMonth = !!systemDay
    ? Formatter.date(String(Number(formatDay) + 1), format)
    : formatDay
  return [
    { id: 0, name: prevMonth },
    { id: 1, name: currentMonth },
    { id: 2, name: nextMonth },
  ]
}

export const DomesticSettlement: React.FC<Props> = props => {
  const displaySymbols = get(store.getState().calender, "symbols")

  const [currentPage, changePage] = useState<number>(0)
  const [displayList, setDisplayList] = useState<Array<object>>(displaySymbols)

  const isPhone = checkIsSp()
  const settlementData = get(props.calenderData, "ResultList", [])
  const settlementTotal = get(props.calenderData, "TotalCount", [])
  const list = chunk(displayList, PAGE_NUM.PAGE_20)

  const systemDay = get(props.calenderData, "SystemDay", "")
  const monthList = getMonthList(systemDay, "YYYY/MM")
  const monthListForMakeCalender = getMonthList(systemDay, "YYYY-MM")

  const changeListType: Function = (id: number) => {
    props.changeDisplayType({ type: id, title: label[id].title })
  }

  const displayDataOfPhone = filter(settlementData, (row: object) => {
    const date = Formatter.date(String(get(row, "Date")), "YYYY/MM")
    return date === monthList[props.settlementMonth].name
  })

  useEffect(() => {
    if (isEmpty(list) && !isEmpty(props.calenderData)) {
      const SystemDay = get(props.calenderData, "SystemDay")
      const ResultList = get(props.calenderData, "ResultList")
      const todayData = find(ResultList, { Date: SystemDay })
      setDisplayList(get(todayData, "Symbols", []))
      store.dispatch(setSymbols(get(todayData, "Symbols", [])))
    }
  }, [props.calenderData])

  useEffect(() => {
    if (!isEmpty(props.calenderData)) {
      const ResultList = get(props.calenderData, "ResultList")
      const currentMonth = filter(ResultList, (data: object) => {
        const selectMonth = get(
          monthList[props.settlementMonth],
          "name"
        ).replace("/", "")
        return String(get(data, "Date")).slice(0, -2) === selectMonth
      })
      const firstData = find(currentMonth, (data: object) => {
        return !isEmpty(get(data, "Symbols"))
      })
      setDisplayList(get(firstData, "Symbols", []))
      store.dispatch(setSymbols(get(firstData, "Symbols", [])))
    }
  }, [props.settlementMonth])

  useEffect(() => {
    changePage(0)
  }, [displayList])

  return isPhone ? (
    <Panel
      title={get(props.displayType, "title")}
      className="panel-calender sp"
    >
      <div className="control-row panel-header-filter filter-control-row">
        <Labels
          className="btn-segmented-control btn-thin liquid-control filter-control-item"
          labelList={label}
          checked={get(props.displayType, "type")}
          onChange={changeListType}
        />
        {get(props.displayType, "type") === label[0].id && (
          <BaseSelect
            option={monthList}
            value={props.settlementMonth}
            onChange={(num: number) => {
              props.changeSettlementMonth(num)
            }}
          />
        )}
      </div>
      {get(props.displayType, "type") === label[0].id ? (
        <div className="table table-striped stock-domestic">
          {map(
            filter(
              displayDataOfPhone,
              (data: object) => !isEmpty(get(data, "Symbols"))
            ),
            (row: object) => (
              <VerticalCalendar
                list={tableColumns.calendar.verticalCalendarDetails}
                data={row}
              />
            )
          )}
        </div>
      ) : (
        <>
          <BaseTable
            className="table-striped stock-foreign"
            list={tableColumns.calendar.foreignSp}
            data={settlementData}
            spFilter={filterColumns.settlementForeign}
            onClick={(data: object) =>
              store.dispatch(changeSpModalSymbol(data))
            }
          />

          <Pagination
            total={settlementTotal}
            list={settlementData}
            current={props.foreignCurrentPage}
            page={PAGE_NUM.PAGE_20}
            changePage={props.foreignChangePage}
          />
        </>
      )}
    </Panel>
  ) : (
    <Panel
      title={get(props.displayType, "title")}
      className="panel-calender"
      // refresh={() => store.dispatch(pageLoad())}
      filter={
        <>
          <div className="control-row panel-header-filter">
            <Labels
              className="btn-segmented-control btn-thin liquid-control filter-control-item"
              labelList={label}
              checked={get(props.displayType, "type")}
              onChange={(num: number) => {
                setDisplayList(get(store.getState().calender, "symbols", []))
                changeListType(num)
              }}
            />
            {get(props.displayType, "type") === label[0].id && (
              <BaseSelect
                option={monthList}
                value={props.settlementMonth}
                onChange={(num: number) => {
                  setDisplayList([])
                  store.dispatch(setMonth(num))
                  props.changeSettlementMonth(num)
                }}
              />
            )}
          </div>
          {/*<span className="panel-header-title-items time">*/}
          {/*  <div className="time-col liquid-item">*/}
          {/*    {Formatter.date(*/}
          {/*      get(props.calenderData, "ServerTime"),*/}
          {/*      "MM/DD HH:mm"*/}
          {/*    )}*/}
          {/*  </div>*/}
          {/*</span>*/}
        </>
      }
    >
      {get(props.displayType, "type") === label[0].id ? (
        <>
          <Calender
            displayList={displayList}
            setDisplayList={setDisplayList}
            calenderData={props.calenderData}
            selectMonth={monthListForMakeCalender[props.settlementMonth].name}
          />
          <BaseTable
            className="table-list-view table-striped list-table"
            list={tableColumns.calendar.domestic}
            data={list[currentPage]}
            onClick={(data: object) => open_symbol_detail(data)}
          />
          <Pagination
            list={displayList}
            current={currentPage}
            page={PAGE_NUM.PAGE_20}
            changePage={changePage}
          />
        </>
      ) : (
        <>
          <BaseTable
            className="table-striped list-table"
            list={tableColumns.calendar.foreign}
            data={settlementData}
            onClick={(data: object) => {
              get(data, "Symbol") && open_symbol_detail(data)
            }}
          />
          <Pagination
            total={settlementTotal}
            list={settlementData}
            current={props.foreignCurrentPage}
            page={PAGE_NUM.PAGE_20}
            changePage={props.foreignChangePage}
          />
        </>
      )}
    </Panel>
  )
}

export const DomesticTodayCalender: React.FC<Props> = props => {
  const [currentPage, changePage] = useState<number>(0)
  const resultList = get(props.calenderData, "ResultList[0].Symbols")
  const list: Array<Array<object>> = chunk(resultList, PAGE_NUM.PAGE_10)

  useEffect(() => {
    changePage(0)
  }, [resultList])

  return (
    <Panel
      title={
        <>
          <span className="panel-header-title-items">本日の決算予定</span>
          <span className="panel-header-title-items day">
            ({Formatter.date(String(dayjs()), "M/D")})
          </span>
          {/*<span className="panel-header-title-items time">*/}
          {/*  <div className="time-col liquid-item">*/}
          {/*    {Formatter.date(*/}
          {/*      get(props.calenderData, "ServerTime"),*/}
          {/*      "MM/DD HH:mm"*/}
          {/*    )}*/}
          {/*  </div>*/}
          {/*</span>*/}
        </>
      }
      className="panel-list-closing panel-fixed-height"
      // refresh={() =>
      //   calenderApi({
      //     setData: props.updateFunc,
      //     today: true,
      //   })
      // }
    >
      <div className="result-list-block">
        <BaseTable
          className="table-list-view table-striped"
          list={tableColumns.calendar.summary}
          data={list[currentPage]}
          onClick={(data: object) => open_symbol_detail(data)}
        />
        <Pagination
          list={resultList}
          current={currentPage}
          page={PAGE_NUM.PAGE_10}
          changePage={changePage}
        />
      </div>
    </Panel>
  )
}
